/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PermissionProfile } from '../models/PermissionProfile';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PermissionsService {
    /**
     * Calculate fan report for specified date range
     * @returns PermissionProfile Permission profile
     * @throws ApiError
     */
    public static createPermissionProfileForTarget({
        memberId,
    }: {
        /**
         * Id of the member the permission profile is addressed to
         */
        memberId: number,
    }): CancelablePromise<PermissionProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/team/permissions/{memberId}',
            path: {
                'memberId': memberId,
            },
            errors: {
                403: `The user is missing the required permission to see access this team member's permission profile (E.g. default member tries accessing or admin tries accessing the owner).`,
            },
        });
    }
}
